import { createContext, type Dispatch, type SetStateAction } from "react";

interface UserUIContextValue {
  fullScreenLayout: boolean;
  setFullScreenLayout:
    | ((open: boolean) => void)
    | Dispatch<SetStateAction<boolean>>;

  /**
   * Whether the app rail is expanded.
   *
   * Shared rather than local to the rail because a screen can need the width:
   * the policy split puts a conversation beside a policy, and at 1320px the
   * rail is a quarter of what is left. A screen asks on the way in and gives
   * it back on the way out; the rail's own toggle wins in between.
   */
  sidebarOpen: boolean;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
}

export const UserUIContext = createContext<UserUIContextValue>({
  fullScreenLayout: false,
  setFullScreenLayout() {},

  sidebarOpen: true,
  setSidebarOpen() {},
});
